import React, { useRef, useState } from "react";
import Indentification from "../elements/Indentification";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

const AvatarUpload = ({
  src,
  initial,
  alt,
  onChange = () => {},
  onRemove = () => {},
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const fileInputRef = useRef();

  function imageUploadHandler(e) {
    const file = e.target.files[0];
    const type = file?.type.split("/")[0];
    if (type === "image") {
      onChange(file);
    } else {
      toast.info("Only image files are allowed.");
    }
  }

  return (
    <div className="flex items-center gap-4">
      <label
        className="h-28 w-28 min-w-20 rounded-full overflow-hidden flex flex-col relative cursor-pointer group"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="h-full w-full">
          <Indentification
            image={src}
            size="max"
            initialclassName="text-2xl"
            className="border-0"
            initial={initial}
            alt={alt}
          />
        </div>
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: isHovered ? "0%" : "100%" }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="bg-black/30 absolute bottom-0 left-0 w-full h-6 flex items-center justify-center text-white text-xs"
        >
          <i className="fa-fw fa-regular fa-camera text-xs"></i>
        </motion.div>

 
        {/* {src && isHovered && (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onRemove();
            }}
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 hover:bg-red-600"
            title="Remove image"
          >
            <i className="fa-regular fa-trash"></i>
          </button>
        )} */}

        <input
          type="file"
          accept="image/*"
          onChange={imageUploadHandler}
          ref={fileInputRef}
          className="hidden"
        />
      </label>
      <div
        className="flex items-center text-sm text-gray-600 cursor-pointer hover:text-black"
        onClick={() => fileInputRef.current?.click()}
      >
        <i className="fa-solid fa-upload mr-2 text-lg"></i>
        Upload image
      </div>
    </div>
  );
};

export default AvatarUpload;
